import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionRoutingModule } from './connection-routing.module'
import { LayoutComponent } from './layout.component'
import {Form, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NewConnectionComponent } from './newconnection.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

import { ProgressComponent } from './progress.component';
import { ProgressStepComponent } from './progress-step/progress-step.component';
import { ProgressStepDirective } from './progress-step.directive';
import { ConnectionNameComponent } from './coonection.name';
import { ConnectionTriggerComponent } from './connection.trigger';
import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import { ConnectionActionComponent } from './connection.action';
import { AutomationListComponent } from './automation.list';
import { PairsPipe } from './pairs.pipe';
import { AuthenticateAPI } from './authenticate.api';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutomationsummeryComponent } from './automationsummery/automationsummery.component';
import { SlackUrlRedirectAuthComponent } from './slack-url-redirect-auth/slack-url-redirect-auth.component';
import { TeamsUrlRedirectAuthComponent } from './teams-url-redirect-auth/teams-url-redirect-auth.component';

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

@NgModule({
  declarations: [
    LayoutComponent,
    NewConnectionComponent,
    ProgressComponent,
    ProgressStepComponent,
    ProgressStepDirective,
    ConnectionNameComponent,
    ConnectionTriggerComponent,
    ConnectionActionComponent,
    AutomationListComponent,
    PairsPipe,
    AuthenticateAPI,
    AutomationsummeryComponent,
    SlackUrlRedirectAuthComponent,
    TeamsUrlRedirectAuthComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    ReactiveFormsModule,
    ConnectionRoutingModule,
    NgxPaginationModule,
    MatFormFieldModule,
    NgbModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    NgWizardModule.forRoot(ngWizardConfig)
  ]
})

export class ConnectionModule { ConnectionRoutingModule}
